'use client';

import React, { useState } from 'react';
import clsx from 'clsx';
import { Component } from '@headless-workspace/typings';
import { GlowIcon, GlowTextBody } from '../../atoms';
import { PropsWithClassName } from '../../props';
import { Icons } from '../../res/icons';

type GlowStarRatingProps = PropsWithClassName & {
    totalStars?: number;
    label?: string;
    id?: string;
    name?: string;
    onChange?: (rating: number) => void;
};

export const GlowStarRating: Component<GlowStarRatingProps> = ({
    totalStars = 5,
    onChange,
    label,
    id,
    name,
    className,
}) => {
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);

    const handleRatingChange = (selectedRating: number) => {
        setRating(selectedRating);
        if (onChange) {
            onChange(selectedRating);
        }
    };

    return (
        <div className={clsx('flex flex-row items-center self-stretch gap-1', className)}>
            <GlowTextBody fontWeight={'bold'} htmlFor={id} TagName={'label'} text={label} color={'primary'} />
            <input type={'hidden'} value={rating} id={id} name={name} className={'hidden'} />

            <div className={'flex items-center'}>
                {[...Array(totalStars)].map((_, index) => {
                    const starValue = index + 1;
                    const isSelected = (hoverRating || rating) >= starValue;

                    return (
                        <div
                            key={index}
                            onMouseEnter={() => setHoverRating(starValue)}
                            onMouseLeave={() => setHoverRating(0)}
                        >
                            <label
                                htmlFor={`rating-${starValue}`}
                                className={clsx('cursor-pointer', isSelected && 'rating-selected-star')}
                            >
                                {isSelected ? (
                                    <GlowIcon Icon={Icons.Star} type={'xLarge'} />
                                ) : (
                                    <GlowIcon Icon={Icons.WhiteStar} type={'xLarge'} />
                                )}
                            </label>

                            <input
                                type={'radio'}
                                value={starValue}
                                id={`rating-${starValue}`}
                                name={`rating-${starValue}`}
                                checked={rating === starValue}
                                onChange={() => handleRatingChange(starValue)}
                                className={'absolute opacity-0'}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
